import React from 'react';
import { useNavigate, NavLink } from 'react-router';

import {Container} from 'react-bootstrap'; 

const ServiceNavigator = ({service}) => {
  const navigate = useNavigate();

  const addElement = () => {
      //alert('addNote or addCrop')
      //global.AddNote()
  }

  return (
    (service === 'Synchronize') ?        
        <Container style={{marginTop: '.7rem'}}>
            <NavLink className="navbar-custom" to="/sync">Home</NavLink>
            <NavLink className="navbar-custom" to="/site">Site</NavLink>
            <NavLink className="navbar-custom" to="/drive">Drive</NavLink>
            <NavLink className="navbar-custom" to="/worker">Worker</NavLink>
            <NavLink className="navbar-custom" to="/detail">Detail</NavLink>
            <NavLink className="navbar-custom" to="/step">Step</NavLink> 
        </Container>
    :
    (service === 'Digitization') ?        
        <Container style={{marginTop: '.7rem'}}>
            <NavLink className="navbar-custom" to="/ocr" onClick={addElement}>Cropping</NavLink>
            <NavLink className="navbar-custom" to="/setting">Setting</NavLink>
        </Container>
    :
    null

  );
};

export {ServiceNavigator}

